import { AuthenticationContext, adalFetch, withAdalLogin } from 'react-adal';

export const adalConfig = {
    tenant: '0ddb51b2-38b8-4153-9c90-ded384f83a88',
    clientId: 'ea8874d1-d0d5-4519-95f6-e6b14dfa28c8',
    endpoints: {
        api: 'ea8874d1-d0d5-4519-95f6-e6b14dfa28c8'
    },
    postLogoutRedirectUri: window.location.origin,
    cacheLocation: 'localStorage'
};
if (process.env.NODE_ENV === 'development') {
    adalConfig.redirectUri = 'https://localhost:44320';
}


export const authContext = new AuthenticationContext(adalConfig);

export const adalApiFetch = (fetch, url, options) => adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints.api);

export const getToken = () => {
    return authContext.getCachedToken(authContext.config.clientId);
};


// WEBPACK FOOTER //
// ./src/config/adalConfig.js